import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import RichtextEditor from '../../../../Core/TextEditor/RichtextEditor'
const Tab1 = ({ brand, setBrand, description, brandName, setDescription, activityboll }) => {
  const status = 'no'
  const [content, setContent] = useState('');
  const [showActivity, setShowActivity] = useState(true);
  return (
    <div>


      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <Input
              id="BrandName"
              label="Brand Name"
              style={{ height: "30px" }}
              readOnly
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
          </div>
        </div>
        <div className="col-6 edit-not-allowed">
          <div className="mb-3">
            <RichtextEditor content={description} setContent={setContent} isEditable={false} />
            {/* <Textarea
              id="BrandDescription"
              label="Description"
              readOnly={status}
              style={{ whiteSpace: 'pre-wrap', backgroundColor: '#f8f6f6' }}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            /> */}
          </div>
        </div>

      </div>
      <div>
        <ActivityCard doctype="Brand" docname={brandName} />
      </div>

    </div>
  )
}

export default Tab1